// Centralised, user-confirmed business information.
export const business = {
  phone: '06 01 92 30 22',
  email: 'contact@sds-serrurier.com',
  hours: 'Selon disponibilité',
  calendlyUrl: '',
  siret: '10829486900012',
  legalForm: 'SASU',
  publicationDirector: 'Didier Baia',
  rcsCity: 'Mulhouse',
  unconvertedRequestRetentionMonths: 6,
  legalName: 'SDS-Serrurier Didier Strasbourg',
  consumerMediator: { name: 'CM2C', address: '49 rue de Ponthieu, 75008 Paris', phone: '01 89 47 00 14', email: 'litiges@cm2c.net', url: 'https://www.cm2c.net/declarer-un-litige.php', validUntil: '2029-09-17' },
  shareCapitalEUR: 500,
  registeredAddress: "9 avenue d’Italie, 68110 Illzach",
  vatNumberProvided: 'FR94108294869',
  // Confirmed by Didier after contacting the tax office, 17 September 2026.
  vatRegime: 'mini-reel',
  vatFilingFrequency: 'monthly',
}

